export const fileToUint8Array = async file => {
  const arrayBuffer = await file.arrayBuffer();
  return new Uint8Array(arrayBuffer);
};
export const mapProjectToProjectInsight = project => {
  var _project$goals, _project$messaging, _project$timeline;
  return {
    name: (project == null ? void 0 : project.name) ?? '',
    goals: (project == null || (_project$goals = project.goals) == null ? void 0 : _project$goals.toLocaleString()) ?? '',
    targetAudience: (project == null ? void 0 : project.targetAudience) ?? '',
    messaging: (project == null || (_project$messaging = project.messaging) == null ? void 0 : _project$messaging.toLocaleString()) ?? '',
    description: (project == null ? void 0 : project.description) ?? '',
    launchDate: (project == null || (_project$timeline = project.timeline) == null || (_project$timeline = _project$timeline.startDate) == null ? void 0 : _project$timeline.toDateString()) ?? ''
  };
};
//# sourceMappingURL=utils.js.map